import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { FaCalendarAlt, FaClock, FaMapMarkerAlt } from 'react-icons/fa'

// Import images (keep existing imports)
import HR1 from '../assets/Events/HR Conclave/IMG_7460.gif';
import JB7 from '../assets/Events/jubin visit/IMG_3082.gif';
import KVM1 from '../assets/Events/KVM 2024/DSC00350.gif';
import { Link } from 'react-router-dom'

const UpcomingEvents = () => {
  const [activeFilter, setActiveFilter] = useState('all')

  const events = [
    {
      id: 1,
      title: "HR Conclave 2.0",
      image: HR1,
      date: "October 26, 2024",
      category: "professional",
      description: "A premier event bringing together HR professionals and industry leaders."
    },
    {
      id: 2,
      title: "Celebrity Visit: Jubin Nautiyal",
      image: JB7,
      date: "November 9, 2024",
      category: "cultural",
      description: "An exclusive interaction with renowned singer Jubin Nautiyal."
    },
    {
      id: 3,
      title: "Krishi Vigyan Mela",
      image: KVM1,
      date: "December 10 & 11, 2024",
      category: "academic",
      description: "Krishi Vigyan Mela: Agricultural innovation and knowledge exchange event."
    }
  ]

  const filterCategories = [
    { name: 'all', label: 'All Events' },
    { name: 'professional', label: 'Professional' },
    { name: 'cultural', label: 'Cultural' },
    { name: 'academic', label: 'Academic' }
  ]

  const filteredEvents = activeFilter === 'all' 
    ? events 
    : events.filter(event => event.category === activeFilter)

  return (
    <div className='w-full py-16 bg-gray-50'>
      <div className='mx-auto px-4'>
        <motion.div 
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className='text-[#0e4d38] text-center font-bold text-4xl uppercase mb-6'>
            Maya Devi Today
          </h2>
          <div className='w-[15%] mx-auto h-1 bg-gradient-to-br from-yellow-200 via-yellow-300 to-amber-300 mb-8'></div>

          {/* Event Filters */}
          <div className='flex justify-center mb-10 space-x-4'>
            {filterCategories.map((category) => (
              <button
                key={category.name}
                className={`
                  px-4 py-2 rounded-full text-sm font-semibold transition-all duration-300
                  ${activeFilter === category.name 
                    ? 'bg-[#0e4d38] text-white' 
                    : 'bg-gray-200 text-gray-700 hover:bg-[#0e4d38] hover:text-white'
                  }
                `}
                onClick={() => setActiveFilter(category.name)}
              >
                {category.label}
              </button>
            ))}
          </div>

          {/* Events Grid */}
          <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-8'>
            {filteredEvents.map((event) => (
              <motion.div
                key={event.id}
                whileHover={{ scale: 1.05 }}
                className='bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-2xl'
              >
                <div className='relative'>
                  <motion.img 
                    src={event.image} 
                    alt={event.title} 
                    className='w-full h-64 object-cover'
                    loading="lazy"
                    decoding="async"
                    initial={{ filter: 'blur(10px)', opacity: 0 }}
                    animate={{ filter: 'blur(0px)', opacity: 1 }}
                    transition={{ duration: 0.5 }}
                    onLoad={(e) => {
                      e.target.style.filter = 'none';
                    }}
                  />
                  <div className='absolute top-4 right-4 bg-[#0e4d38] text-white px-3 py-1 rounded-full text-sm'>
                    {event.category}
                  </div>
                </div>
                
                <div className='p-6'>
                  <h3 className='text-2xl font-bold text-[#0e4d38] mb-3'>
                    {event.title}
                  </h3>
                  <p className='text-gray-600 mb-4'>
                    {event.description}
                  </p>
                  
                  <div className='flex items-center text-sm text-gray-500 mb-4'>
                    <FaCalendarAlt className='mr-2 text-[#0e4d38]' />
                    {event.date}
                  </div>
                </div>
                
                <div className='bg-gradient-to-br from-yellow-200 via-yellow-300 to-amber-300 p-4 text-center'>
                  <Link 
                    to="/events" 
                    className='text-[#0e4d38] font-bold hover:underline'
                  >
                    Learn More
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>

          {/* View All Events Button */}
          <div className='text-center mt-12'>
            <Link 
              to="/events"
              className='
                inline-block 
                bg-[#0e4d38] 
                text-white 
                px-8 py-3 
                rounded-full 
                font-semibold 
                hover:bg-[#145a46] 
                transition-colors 
                duration-300
              '
            >
              View All Events
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default UpcomingEvents